import BaseAPI from "./BaseAPI";
import { wastageRoute } from "../routes";

export default class WastageAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, wastageRoute, "wastage");
    }

    async Record(data, key) {
        const result = await this._request("post", this._url("/record"), data, {
            headers: { "Idempotency-Key": key }
        });
        this._emit("add", result.id);
        return result;
    }

    /**
     * List wastage records filtered by type.
     * @param {string} type - Wastage type (INGREDIENT, MEAT, PACKAGING, PREPARED_FOOD)
     * @returns {Promise<Array>} Array of wastage records
     */
    async ListByType(type) {
        return this._request("get", this._url(`?wastage_type=${type}`));
    }

    /**
     * List wastage records filtered by stock ID.
     * @param {string} stockID - Stock ID to filter by
     * @returns {Promise<Array>} Array of wastage records
     */
    async ListByStockID(stockID) {
        return this._request("get", this._url(`?stock_id=${stockID}`));
    }

    /**
     * List wastage records filtered by reason.
     * @param {string} reason - Reason code (EXPIRED, SPOILED, DAMAGED, OVERPRODUCTION, CUSTOMER_RETURN, OTHER)
     * @returns {Promise<Array>} Array of wastage records
     */
    async ListByReason(reason) {
        return this._request("get", this._url(`?reason=${reason}`));
    }
}
